export default class MeetingService {

    constructor(axios) {
        this.axios = axios;
    }

    joinMeeting(data) {
        return this.axios.post('/meeting/join', data);
    }

    updateMembers(meeting_code, { members_add }) {
        return this.axios.put(`/meeting/${meeting_code.split(' ').join('')
.toLowerCase()}/update-members`, { members_add });
    }

    getMeeting(meeting_code) {
        return this.axios.get(`/meeting/${meeting_code.split(' ').join('')
.toLowerCase()}`);
    }

    getMember(meeting_code, token) {
        return this.axios.get(`/meeting/${meeting_code.split(' ').join('')
.toLowerCase()}/member?token=${token}`);
    }

    getPreviousMembers(meeting_code) {
        return this.axios.post('/meeting/get-all-previous-members', { meetingName: meeting_code });
    }

    // v1.0 section 4.2.3: named meetings (used when the named_meetings flag is on).
    listMeetings() {
        return this.axios.get('/meeting/list');
    }

    renameMeeting(meeting_code, name) {
        return this.axios.patch(`/meeting/${meeting_code}`, { name });
    }

    deleteMeeting(meeting_code) {
        return this.axios.delete(`/meeting/${meeting_code}`);
    }
}

